import React, { Component } from "react";
import "./style.css";

class Welcome extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="Welcome">
          <p>Welcome Lokesh Bolisetty</p>
          <p>Happy to see you again</p>
        </div>
      </React.Fragment>
    );
  }
}

export default Welcome;
